import React, { useRef, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import InterestingNewsCard from './intrestingNewsCard.jsx';
import Skeleton from '../skelton.jsx';

const SIDE_ITEMS_COUNT = 5;

const NewsContentSide = ({ moreNews: ssrMoreNews, ssrContentId, ssrCatId }) => {

  const { contentText } = useParams();

  // const [prevNews, setPrevNews] = useState(null);
  // const [nxtNews, setNxtNews] = useState(null);
  const [moreNews, setMoreNews] = useState(ssrMoreNews);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const contentid = contentText.substring(contentText.lastIndexOf('-') + 1, contentText.lastIndexOf('.html'));
  const cut = contentText.substring(0, contentText.lastIndexOf('-'));
  const catid = cut.substring(cut.lastIndexOf('-') + 1);
  const contentIdRef = useRef(ssrContentId);
  const catIdRef = useRef(ssrCatId);

  const fetchAttemptedRef = useRef(false);

  const catLinks = {
    25: "/contents/latestnews-25.html",
    36: "/contents/latestnews-25.html",
    45: "/contents/analytical-45.html",
    39: "/contents/politics-39.html",
    35: "/contents/lifestyle-35.html",
    34: "/contents/health-34.html",
    60: "/contents/specialAnalysis-60.html", 
    43: "/contents/andhrapradesh-43.html",
    24: "/contents/telangana-24.html",
    23: "/contents/india-23.html",
    58: "/contents/world-58.html",
    54: "/contents/business-54.html",
    33: "/contents/technology-33.html",
    53: "/contents/sports-53.html",
    55: "/contents/teluguoneexclusive-55.html",
    57: "/contents/history-57.html",
  };

  useEffect(() => {
    fetchAttemptedRef.current = false;
  }, [contentText]);

  useEffect(() => {

    const fetchData = async () => {
      try {
        setLoading(true);
        const results = await Promise.allSettled([
          fetch(`https://www.teluguone.com/news_api/newsDetailedMoreNewsJson?catid=${catid}&contentid=${contentid}`),
          // fetch(`https://www.teluguone.com/news_api/newsDetailedPrevJson?catid=${catid}&contentid=${contentid}`),
          // fetch(`https://www.teluguone.com/news_api/newsDetailedNextJson?catid=${catid}&contentid=${contentid}`)
        ]);

        const safeJson = async r =>
          r.status === "fulfilled" && r.value.ok
            ? r.value.json().catch(() => null)
            : null;

        const [more] =
        // const [more, prev, nxt] =
          await Promise.all(results.map(safeJson));

        setMoreNews(more?.morenews || null);
        // setPrevNews(prev?.prvnews?.[0] || null);
        // setNxtNews(nxt?.nxtnews?.[0] || null);
      } catch (e) {
        console.error(e);
        setError(e.message);
      } finally {
        contentIdRef.current = contentid;
        catIdRef.current = catid;
        setLoading(false);
      }
    };

    fetchData();
    fetchAttemptedRef.current = false;

  }, [contentText]);

  // const prevId = prevNews?.prev_id;
  // const nextId = nxtNews?.next_id;
  
  // const finalMoreNews = Array.isArray(moreNews)
  //   ? moreNews
  //     .filter(item => {
  //       const url = item?.url_link || '';
  //       if (prevId && new RegExp(`-${prevId}\\.`, 'i').test(url)) return false;
  //       if (nextId && new RegExp(`-${nextId}\\.`, 'i').test(url)) return false;
  //       return true;
  //     })
  //     .slice(0, SIDE_ITEMS_COUNT)
  //   : [];

  return (
    <div className='news-content-side'>
      {loading && (
        <div className="loader-div">
          <div className='container-fluid'>
            {Array.from({length: SIDE_ITEMS_COUNT }).map((_, i) => (
              <div className='row mt-2 mb-2' key={i}>
                <div className='col-12 col-sm-5 intresting-news-img-container'><Skeleton type={"int-news-square"} /></div>
                <div className='col-12 col-sm-7'>
                  <Skeleton type={"title"} />
                  <Skeleton type={"paragraph"} />
                  <Skeleton type={"paragraph"} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {!loading && moreNews && moreNews.length > 0 && (
        <>
          <div
            className={`news-content-side-header notranslate`}
            translate="no"
          >
            Related News
          </div>

          {moreNews.map((item, i) => (
            <InterestingNewsCard
              key={item.url_link}
              keyTarget="_self"
              more="more"
              index={i}
              data={item}
            />
          ))}

          <div className={`latest-side-news-view-more`}>
            <Link to={catid ? catLinks[Number(catid)] : '/'}>
              <button className="latest-side-news-view-more-btn notranslate" type="button" translate="no">
                View More..
              </button>
            </Link>
          </div>
        </>
      )}

      {!loading && moreNews && moreNews.length === 0 && error && (
        <div className='json-loading-error-div'>
          <img src={`${import.meta.env.BASE_URL}assets/images/json_error.png`} alt="json_error" />
        </div>
      )}

    </div>
  );
};

export default NewsContentSide;
